import { Directive, inject, TemplateRef } from '@angular/core';

/** Marks an `ng-template` as a cfg-table's custom empty state (overrides `emptyText`). */
@Directive({ selector: 'ng-template[cfgEmpty]' })
export class CfgEmptyDirective {
  readonly templateRef = inject(TemplateRef);
}
